import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Transition from 'semantic-ui-react/dist/es/modules/Transition';
import 'semantic-ui-css/components/transition.min.css';

import './Welcome.css';
import { WelcomeSplash, Button } from 'web-store-modules/packages/web-store-ui-library/'
import { getWelcomeExploreUrlAsync } from '../../../utils/StaticAssetManager.js';
import { getWelcomeMessageStyleAsync, getWelcomeTitleAsync, getStyleColorAsync, popupStoreId, exhibitStoreId } from '../../../utils/StoreConfigManager.js';
import { isMobileDevice } from 'web-store-modules/packages/obsess-device-detector';
import { storeId } from '../../../../../variables/Variables';
import WelcomeTooltip from './WelcomeTooltip/WelcomeTooltip';
import CustomWelcomeScreen from './CustomWelcomeScreen/CustomWelcomeScreen';

const defaultFontFamily = 'sans-serif';
const welcomeGif = "https://cdn.obsess-vr.com/umg/25_Logo_BlackBG.gif"
const isMobile = isMobileDevice();

const welcomeShowTime = isMobile ? 4000 : 7000;
const WelcomeTooltipShowTime = isMobile ? 7000 : 10000;
const desktopGifAnimation = !isMobile && storeId === popupStoreId ? {position: 'relative',top: '50%'} : {};

class Welcome extends Component {
    constructor(props) {
        super(props);
        this.hide = this.hide.bind(this);
        this.onHide = this.onHide.bind(this);
        this.onShowTooltip = this.onShowTooltip.bind(this)
        this.state = {
            text: '',
            imageSrc: '',
            visible: true,
            welcomeMessageStyle: null,
            pendingLoadAssetCount: 3,
            primaryColor: '',
            secondaryColor: '',
            visibleTooltip: false,
            showWelTooltip: true,
            showBroseTooltip: false,
            showProductTooltip: false,
            showBeautyTooltip: false,
            showOverlay: storeId === popupStoreId ? true : false,
            showMobileTooltip: false
        };

        this.timeOutFunction = null;
        this.timeOutBrowseFunc = null;
        this.timeOutProductFunc = null;
        this.timeOutBeautyFunc = null;
    }

    componentDidMount() {
        getWelcomeMessageStyleAsync()
            .then(style => {
                if (style) {
                    const welcomeMessageStyle = {
                        fontFamily: style.name + ',' + defaultFontFamily
                    };
                    if (!isMobile) {
                        welcomeMessageStyle.fontSize = style.size;
                    }
                    this.setState(state => {
                        return {
                            welcomeMessageStyle: welcomeMessageStyle,
                            pendingLoadAssetCount: state.pendingLoadAssetCount - 1
                        };
                    });
                }
            })
            .catch(error => console.error(error));

        getStyleColorAsync()
            .then(style => {
                const primaryColor = style[0];
                const secondaryColor = style[1];
                this.setState({ primaryColor, secondaryColor })
            })
            .catch(error => console.error(error));

        getWelcomeTitleAsync()
            .then(welcomeText => {
                let  newWelomeMgs = welcomeText.split("!");
                let text = <span> {newWelomeMgs[0]}! <br /> {newWelomeMgs[1]}</span>;
                this.setState(state => {
                    return {
                        text: storeId === popupStoreId ? text : welcomeText,
                        pendingLoadAssetCount: state.pendingLoadAssetCount - 1
                    };
                });
            })
            .catch(error => console.error(error));

        getWelcomeExploreUrlAsync()
            .then(url => {
                const welcomeImage = new Image();
                welcomeImage.onload = () => {
                    this.setState(state => {
                        return {
                            pendingLoadAssetCount: state.pendingLoadAssetCount - 1
                        };
                    });
                }
                welcomeImage.src = url;
                this.setState({ imageSrc: url })
            })
            .catch(error => console.error(error));

    }

    componentWillUnmount() {
        if (isMobile) {
            window.removeEventListener('touchend', this.hideWelcomeTooltips);
        } else {
            window.removeEventListener('click', this.hideWelcomeTooltips);
        }
        clearTimeout(this.timeOutProductFunc);
        clearTimeout(this.timeOutBeautyFunc);
        clearTimeout(this.timeOutBrowseFunc);
        if (this.timeOutFunction) {
            clearTimeout(this.timeOutFunction);
        }
    }

    hide() {
        this.setState({ visible: false });
    }

    onHide() {
        if(storeId === popupStoreId && isMobile){
            this.setState({ welcomeFadeout: 'welcome-fadeout' });
            this.onShowTooltip();
        }else{
            this.props.onWelcomeHide();
        }
    }

    getUpdatedWelcomeMessageStyle() {
        const { isFlatImageScene } = this.props;
        const { welcomeMessageStyle } = this.state;
        const updatedWelcomeMessageStyle = { ...welcomeMessageStyle, fontSize: 36 };

        return isFlatImageScene ? updatedWelcomeMessageStyle : welcomeMessageStyle;
    }

    onShowTooltip = () => {
        if (this.state.showWelTooltip) {
            this.timeOutBrowseFunc = setTimeout(
                () => this.setState({ showWelTooltip: false, showBroseTooltip: true, visibleTooltip: true,showOverlay:true }),
                100
            );

            this.timeOutProductFunc = setTimeout(() =>
                this.setState({ showProductTooltip: true }), 100);
            this.timeOutBeautyFunc = setTimeout(() =>
                this.setState({ showBeautyTooltip: true }), 100);

            setTimeout(() => {
                this.setState({ visibleTooltip: false, showOverlay: false});
                this.props.onWelcomeHide();
            }, WelcomeTooltipShowTime);
        }
    }



    render() {
        const { showingUI, isFlatImageScene, flatImageButtonOption, flatImageButtonText } = this.props;
        const { text, visible, pendingLoadAssetCount, primaryColor, secondaryColor,welcomeFadeout, showBroseTooltip, showProductTooltip, showBeautyTooltip, visibleTooltip, showOverlay, showMobileTooltip } = this.state;
        
        if (!showingUI || pendingLoadAssetCount > 0) {
            return <React.Fragment />;
        }
        if (!this.timeOutFunction) {
            if (isMobile) {
                window.addEventListener('touchend', this.hide);
                window.addEventListener('touchend', this.props.onWelcomeHide);
            } else {
                window.addEventListener('click', this.hide);
                window.addEventListener('click', this.props.onWelcomeHide);
            }

            if(storeId === popupStoreId && !isMobile){
                this.setState({ welcomeFadeout: 'welcome-fadeout' });
                this.onShowTooltip();
            }
                // this.timeOutFunction = setTimeout(() => {
                //     this.hide();
                // }, welcomeShowTime);
            
        }

        return (
            <div id={showOverlay ? 'welcome-overlay' : ''} className={welcomeFadeout}>
                <Transition
                    visible={visible}
                    animation='fade'
                    duration={300}
                    onHide={this.onHide}
                >
                    {
                        storeId === exhibitStoreId ? <CustomWelcomeScreen welcomeText={text} /> :
                    
                    <div className={storeId === popupStoreId ? 'welcome-gif-container' : ''} style={desktopGifAnimation}>
                        <WelcomeSplash
                            welcomeMessageStyle={this.getUpdatedWelcomeMessageStyle()}
                            welcomeText={text}
                            hideTooltip={storeId === popupStoreId ? true : isFlatImageScene}
                        >
                            {
                                flatImageButtonOption &&
                                <Button
                                    style={{ ...this.getUpdatedWelcomeMessageStyle(), padding: '0.2em 1em', marginTop: '0.5em' }}
                                    primaryColor={primaryColor}
                                    secondaryColor={secondaryColor}
                                >
                                    <p id='flat-image-button-text'>{flatImageButtonText}</p>
                                </Button>
                            }
                            {storeId === popupStoreId && <div className="welcome-gif-animation">
                                <img width='180px'  src={welcomeGif} alt="welcome-gif" />
                            </div>}
                        </WelcomeSplash>
                    </div>
                    }
                
                </Transition>
            {visibleTooltip && storeId === popupStoreId && 
                <Transition
                    visible={visibleTooltip}
                    animation='fade'
                    duration={500}
                >
                    <WelcomeTooltip 
                        welcomeMessageStyle={this.getUpdatedWelcomeMessageStyle()}
                        showBroseTooltip={showBroseTooltip}
                        showBeautyTooltip={showBeautyTooltip}
                        showProductTooltip={showProductTooltip}
                        showMobileTooltip={showMobileTooltip}
                        isVisible={visibleTooltip}
                        onWelcomeHide={this.props.onWelcomeHide}
                        isMobile={isMobile} 
                    >
                    </WelcomeTooltip>
                </Transition>
            }
            </div>
        );
    }
}

Welcome.propTypes = {
    showingUI: PropTypes.bool,
    onWelcomeHide: PropTypes.func,
    isFlatImageScene: PropTypes.bool,
    flatImageButtonOption: PropTypes.bool,
    flatImageButtonText: PropTypes.string,
};

export default Welcome;
